import React from "react"
import Popup from "reactjs-popup"

import Protected from "../../../components/Protected/Protected"
import InfoPopup from "../../../components/InfoPopup"
import DeletePositionPopup from "./DeletePositionPopup"
import CreateUpdatePositionPopup from "./CreateUpdatePositionPopup"

import CustomScrollableTable from "../../../toolkits/CustomScrollableTable"
import {EmptyResult} from "../../../toolkits/EmptyResult/EmptyResult"


import {PERMISSIONS} from "../../../constants/permissions"
import {useTranslation} from "react-i18next"


export const EmployeePositionsTable = ({employeePositions, onSubmit, setUserMessage, empty}) => {
    const {t} = useTranslation("common")

    const positionsList = employeePositions.map((employeePosition, i) => {
        const popupParams = {
            position: employeePosition,
            onSubmit: onSubmit,
            setUserMessage: setUserMessage,
        }
        const actions = (
            <>
                <Popup trigger={<span className="custom-scrollable-table-link"> {t("Edit")} </span>} modal>
                    {close => (
                        <CreateUpdatePositionPopup {...popupParams} close={close}/>
                    )}
                </Popup>
                <Popup trigger={<span className="custom-scrollable-table-link"> {t("Delete")} </span>} modal>
                    {close => (
                        <DeletePositionPopup {...popupParams} close={close}/>
                    )}
                </Popup>
            </>
        )

        return (
            <tr key={`${i} ${employeePosition.id}`} className="custom-scrollable-table-row employee-positions-content-table-row">
                <td>
                    <Popup trigger={
                        <span className="cell-limited-text employee-positions-content-table-first-column t-s1 clickable">{employeePosition.name}</span>
                    } modal>
                        {close => (
                            <InfoPopup
                                title={t("Position")}
                                value={employeePosition.name}
                                close={close}
                            />
                        )}
                    </Popup>
                </td>
                <td>
                    <Protected permissions={[PERMISSIONS.WRITE_EMPLOYEE_POSITION]}>
                        {actions}
                    </Protected>
                </td>
            </tr>
        )
    })
    
    return (
        <CustomScrollableTable>
            <table className="employee-positions-content-table">
                <thead>
                    <tr>
                        <th><span className="custom-scrollable-table-head-span">{t("Position")}</span></th>
                        <th><span className="custom-scrollable-table-head-span">{t("Actions")}</span></th>
                    </tr>
                </thead>
                <tbody>
                    {positionsList}
                    {empty && <div className="employee-positions-content-empty-result"><EmptyResult/></div>}
                </tbody>
            </table>    
        </CustomScrollableTable>
    )
}

export default EmployeePositionsTable
